import React from "react"
import { Row, Col } from "react-bootstrap"

import StoryblokImage from "../../internal/storyblokImage/StoryblokImage";
import * as styles from "./speakerWidget.module.scss"

const speakerWidget = ({ blok }) => {
  return (
    <Row className="align-items-center">
      <Col md={"auto"}>
        {blok.speaker_image && blok.speaker_image.filename ? (
          <StoryblokImage sbImageData={blok.speaker_image} />
        ) : (
          "def_start"
        )}
      </Col>
      <Col md={"8"}>
      {blok.speaker_name ? (
          <div className={styles.speakerName}>
            {blok.speaker_name}
            {/* <br /> */}
          </div>
        ) : null}
        {blok.speaker_label ? (
          <div className={styles.speakerLabel}>
            {blok.speaker_label}
            {/* <br /> */}
          </div>
        ) : null}
        {blok.speaker_tagline ? (
          <div className={styles.speakerContent}>
            {blok.speaker_tagline}
          </div>
        ) : null}
      </Col>
    </Row>
  );
};

export default speakerWidget;
